export default "__VITE_ASSET__Cj3Xfaav__"